/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_DescriptionInputs */

const en_wc_guides_description = /** @type {(inputs: Wc_Guides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four in-depth guides, from your first document to a reliable browser workflow. Practical examples, real screenshots, and checks you can follow.`)
};

/**
* | output |
* | --- |
* | "Four in-depth guides, from your first document to a reliable browser workflow. Practical examples, real screenshots, and checks you can follow." |
*
* @param {Wc_Guides_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_description = /** @type {((inputs?: Wc_Guides_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_description(inputs)
});
export { wc_guides_description as "wc.guides.description" }